import React from 'react';
import { NavLink } from 'react-router-dom';
import ScrollToTop from 'components/scroll-to-top';

import './style.css';

const ApiPage = () => (
  <div className="l-api-page">
    <ScrollToTop />
    <div className="products-header -single">
      <h1>AirQast API</h1>
      <p> From our API to your software.</p>
    </div>
    <div className="container">
      <div className="row">
        <div className="col-sm">
          <div className="container">
            <div className="row justify-content-md-center">
              <div className="col-md-10">
                <div className="content-description">
                  <p> API to query the AirQast Platform catalogue and download products (as tiles, time series or raw files). Most endpoints require authentication, which is takes the form of session cookies. When a request to the /login endpoint succeeds, a cookie is set on the browser by the AirQast Platform back-end. This cookie is valid for 2 days, but can be removed by the client by sending a request to the /logout endpoint. Cookies are automatically sent along subsequent queries. Note that you can also send a request to /verifyToken to validate the current session, or delete the cookie if needed.</p>
                </div>
                <a className="api-link" href="https://swagger.airqast.com/">
                  Go to API
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="container">
      <div className="row">
        <div className="col">
          <div className="about-contact">
            <NavLink className="c-button -contact" to="/contact-us">
              Contact
              </NavLink>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ApiPage;



// WEBPACK FOOTER //
// ./src/pages/api/index.js